// Global boolean converters



/**
 * Converts a boolean to "Y" or "N"
 * @param {boolean} value - true or false
 * @returns {"Y" | "N"}
 */

// Too harsh
//export const B2S = (value) => (value === true ? "Y" : "N");

export const B2S = (value) => {

    // Only convert if the value is explicitly a boolean
    if (typeof value === 'boolean') {

        return value ? 'Y' : 'N';

    }

    return value;

};



/**
 * Converts "Y" or "N" to a boolean
 * @param {"Y" | "N" | undefined | null} value
 * @returns {boolean}
 */

export const S2B = (value) => value === "Y";



// Send an array of data and stringify all booleans - return the updated data
export const stringifyBooleans = (data) => {

    // Handle arrays
    if (Array.isArray(data)) {

        return data.map(item => stringifyBooleans(item));

    }

    // Handle objects
    if (typeof data === 'object' && data !== null) {

        const result = {};

        for (const key in data) {

            result[key] = stringifyBooleans(data[key]);

        }

        return result;

    }

    // Convert boolean to string, otherwise return as-is
    return B2S(data);

};